var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShelveComponent',{attrs:{"shelve":_vm.warehouse.shelves[Number(_vm.$route.params.shelve_index) - 1]},on:{"change":_vm.changeHappened}})}
var staticRenderFns = []

export { render, staticRenderFns }